import { render, staticRenderFns } from "./ReceiveReadOnlyCmp.vue?vue&type=template&id=24472338&scoped=true"
import script from "./ReceiveReadOnlyCmp.vue?vue&type=script&lang=js"
export * from "./ReceiveReadOnlyCmp.vue?vue&type=script&lang=js"
import style0 from "./ReceiveReadOnlyCmp.vue?vue&type=style&index=0&id=24472338&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24472338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24472338')) {
      api.createRecord('24472338', component.options)
    } else {
      api.reload('24472338', component.options)
    }
    module.hot.accept("./ReceiveReadOnlyCmp.vue?vue&type=template&id=24472338&scoped=true", function () {
      api.rerender('24472338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/serviceOroviderOrder/component/EditCmp/ReceiveReadOnlyCmp.vue"
export default component.exports